import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Layout from '../../components/Layout';
import GedUploader from '../../components/GedUploader';

export default function GED() {
  const { t } = useTranslation('ged');
  const [searchParams] = useSearchParams();
  const sinistreParam = searchParams.get('sinistre') || '';

  return (
    <Layout title="OssanGED by OSSANASUR">
      <div className="cb-page-header">
        <div>
          <h1 className="cb-page-title">{t('depot.titre')}</h1>
        </div>
      </div>

      <div className="cb-card">
        <GedUploader sinistreId={sinistreParam || undefined} />
      </div>
    </Layout>
  );
}
